import React from 'react';

const NoResults = ({ searchQuery }) => {
    const noResultsText = 'Ոչինչ չի գտնվել';
    const tryAgainText = 'Փորձեք օգտագործել այլ որոնողական բառեր';

    return (
        <div className="noResults" style={{ textAlign: 'center', padding: '40px' }}>
            <i className="fas fa-search-minus mb-3" style={{ fontSize: '3rem', color: '#adb5bd' }} />
            <p className="noResults__title" style={{ fontWeight: '600', fontSize: '1.2rem' }}>
                {noResultsText}
            </p>
            {searchQuery && (
                <p className="noResults__subtitle text-muted">
                    <strong>"{searchQuery}"</strong> բառով ոչինչ չի գտնվել: {tryAgainText}
                </p>
            )}
        </div>
    );
};

export default NoResults;
